document.addEventListener("DOMContentLoaded", function() {

    document.addEventListener('click', function (event) {
        let readTyreModal = document.getElementById('read-tyre-modal');

        //if the clicked element is a play/pause button
        if (event.target.matches('.open-read-tyre-modal')) {
            readTyreModal.classList.remove('hidden');
            document.body.classList.add('read-tyre-modal-open');
			
        }

        if (event.target.matches('#read-tyre-modal-close')) {	
            readTyreModal.classList.add('hidden');
            document.body.classList.remove('read-tyre-modal-open');

        }
 
    });
    
});